import { Controller } from "stimulus"

// Mirrors the live value of a source input into one or more text nodes.
// data-controller="liveText" on a wrapper containing the source input
// (data-liveText-target="source", data-action="input->liveText#sync")
// and the output span(s) (data-liveText-target="output", data-liveText-placeholder-param="...").
export default class extends Controller {
  static targets = ["source", "output"]

  connect() {
    this.sync()
  }

  sync() {
    this.sourceTargets.forEach((source) => {
      const output = this.outputTargets.find((candidate) => candidate.dataset.liveTextFor === source.dataset.liveTextFor)
      if (!output) return

      output.textContent = source.value.trim() || output.dataset.liveTextPlaceholder
    })
  }
}
